import { ReactNode } from "react";
import { Flex, Text } from "@radix-ui/themes";
import { ExploreInteractionRow } from "@/v2/entities/explore/Explore.model";

export function InteractionViewHeader({
  interaction: { subject, displayId },
  rightAction,
}: {
  interaction: ExploreInteractionRow;
  rightAction?: ReactNode;
}) {
  return (
    <Flex py={"12px"} px={"26px"} align={"start"} justify={"between"} gap={"3"}>
      <Flex direction={"column"} gap={"1"} style={{ minWidth: 0, flex: 1 }}>
        <Text size={"5"} weight={"medium"} color={"gray"} highContrast truncate>
          {subject}
        </Text>

        <Text size={"2"} color="gray">
          {`#${displayId}`}
        </Text>
      </Flex>

      {rightAction != null && <Flex flexShrink={"0"}>{rightAction}</Flex>}
    </Flex>
  );
}
